import { EventVenue } from '@/components/EventDetails/EventVenue/EventVenue';
import { useBasicInfo } from '@/components/_shared/contexts/BasicInfoContext';

import { ConversionBarEventDateTime } from './ConversionBarEventDateTime';
import twoRailsStyles from './ConversionBarTwoRails.module.scss';

export const ConversionBarTwoRailsEventMeta: React.FC = () => {
  const { venue, isOnline } = useBasicInfo();

  return (
    <>
      <ConversionBarEventDateTime />
      <div className={twoRailsStyles.location}>
        <EventVenue venue={venue} isOnline={isOnline} />
      </div>
    </>
  );
};
